'use client';

import { Select } from './select';

/** One filter above a list, in the shape every screen uses: the unset option
 *  is "every …", each option says how many rows it would leave, and a field
 *  with nothing at all to choose from draws nothing. */
export function FilterPick<T>({
  label,
  every,
  value,
  onChange,
  rows = [],
  of,
  counted,
  word,
}: {
  label: string;
  every: string;
  value: string;
  onChange: (next: string) => void;
  rows?: readonly T[];
  of?: (row: T) => string | null;
  /** Counts the server already made, for a list it holds and the page does not. */
  counted?: ReadonlyArray<{ value: string; count: number }>;
  word: (key: string) => string;
}) {
  const counts = new Map<string, number>(counted?.map((one) => [one.value, one.count]));
  for (const row of counted ? [] : rows) {
    const key = of?.(row);
    if (key) counts.set(key, (counts.get(key) ?? 0) + 1);
  }
  const total = counted ? counted.reduce((sum, one) => sum + one.count, 0) : rows.length;
  /* Drawn even where today happens to hold one answer: this screen promises
     the filter, and a control that comes and goes with the data reads as the
     screen having lost it. Nothing at all to choose from is still nothing. */
  if (counts.size === 0) return null;
  return (
    <Select
      size="sm"
      aria-label={label}
      placeholder={every}
      value={value}
      options={[
        { value: '', label: every, count: total },
        ...[...counts.entries()]
          .sort((a, b) => b[1] - a[1])
          .map(([key, count]) => ({ value: key, label: word(key), count })),
      ]}
      onChange={onChange}
    />
  );
}
